const normalizeSources = sourcePayload => {
	if (Array.isArray(sourcePayload)) {
		return sourcePayload.filter(Boolean);
	}

	if (!sourcePayload) {
		return [];
	}

	return [sourcePayload];
};

const buildAssistantMessageItem = (content, index) => {
	const rawMessage = typeof content === "string" ? content : (content?.content ?? "");
	const message = typeof rawMessage === "string" ? rawMessage : "";
	const sources = normalizeSources(content?.sources ?? content?.source);

	if (!message.trim() && sources.length === 0) {
		return null;
	}

	return {
		id: `message-item-${index + 1}`,
		message,
		sources
	};
};

const appendAssistantMessageItem = (items = [], content) => {
	const safeItems = Array.isArray(items) ? items : [];
	const nextItem = buildAssistantMessageItem(content, safeItems.length);

	if (!nextItem) {
		return safeItems;
	}

	return [...safeItems, nextItem];
};

export default appendAssistantMessageItem;
